var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6665 18.1667C15.8832 17.1833 14.6665 16.1667 14.6665 14.5833C14.6665 12.7667 16.3499 11.5 19.1665 11.5C22.1332 11.5 23.2332 12.9167 23.3332 15H27.0165C26.8999 12.1333 25.1499 9.5 21.6665 8.65V5H16.6665V8.6C13.4332 9.3 10.8332 11.4 10.8332 14.6167C10.8332 18.4667 14.0165 20.3833 18.6665 21.5C22.8332 22.5 23.6665 23.9667 23.6665 25.5167C23.6665 26.6667 22.8499 28.5 19.1665 28.5C15.7332 28.5 14.3832 26.9667 14.1999 25H10.5332C10.7332 28.65 13.4665 30.7 16.6665 31.3833V35H21.6665V31.4167C24.9165 30.8 27.4999 28.9167 27.4999 25.5C27.4999 20.7667 23.4499 19.15 19.6665 18.1667Z",
    fill: "url(#paint0_linear_1125_938)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_938",
    x1: 19.0165,
    y1: 5,
    x2: 19.0165,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.3aa5be4ba28f9e70b241d75001b16f4f.svg";
export { ForwardRef as ReactComponent };